import React from "react";
import "./index.css";
// import PartyImage from "../public/assets/partySvgImage.svg";

function HeroSection({
  handleToggle = () => {},
  handleCounsollerToggle = () => {},
  isMobile
}) {
  return (
    <section className="oxford_mun_new_hero-section">
      <div className="hero-container">
        <img
          src={`/assets/images/OxfordMunNew/${isMobile ? "hero_section_oxfrodmun_new_full" : "hero_section_oxfrodmun_new_cut"}.svg`}
          alt="Party"
          className="hero-image"
        />

        {/* Overlay Text */}
        <div className="hero-text-overlay">
          <h1 className="hero-title">OXFORDMUN India 2025</h1>
          <p className="hero-paragraph">
            OxfordMUN, a global leader in diplomatic simulations, returns to
            India for its second edition at FLAME University, Pune, from 4th to
            6th August 2025. Led by the MU20 School of Opportunity, this
            prestigious conference seamlessly blends Oxford’s tradition of
            academic excellence with India’s dynamic cultural diversity,
            offering delegates a transformative experience in diplomacy, debate,
            and leadership.
          </p>
        </div>

        <div className="hero-buttons">
          <button className="hero-button" onClick={handleToggle}>
            REGISTER NOW
          </button>
          <a
            className="hero-button secondary-anch"
            href="https://bit.ly/OxfordMUNIndia2025Brochure"
            target="_blank"
          >
            DOWNLOAD BROCHURE
          </a>
          <button className="hero-button" onClick={handleCounsollerToggle}>
            CONNECT WITH A COUNSELLOR
          </button>
        </div>
      </div>

      <div className="mobile-section sm-hidden">
        <div className="text-content">
          <h1 className="mobile-title">OXFORDIUM India 2025</h1>
          <p className="mobile-paragraph">
            OxfordMUN, a global leader in diplomatic simulations, returns to
            India for its second edition at FLAME University, Pune, from 4th to
            6th August 2025. Led by the MU20 School of Opportunity, this
            prestigious conference seamlessly blends Oxford’s tradition of
            academic excellence with India’s dynamic cultural diversity,
            offering delegates a transformative experience in diplomacy, debate,
            and leadership.
          </p>
        </div>

        <div className="mobile-buttons">
          <button className="hero-button" onClick={handleToggle}>
            REGISTER NOW
          </button>
          <a
            className="hero-button secondary-anch"
            href="https://bit.ly/OxfordMUNIndia2025Brochure"
            target="_blank"
          >
            DOWNLOAD BROCHURE
          </a>
          <button className="hero-button" onClick={handleCounsollerToggle}>
            CONNECT WITH A COUNSELLOR
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
